/**
 * WarehouseLogix — admin + platform API contracts (FROZEN at SME ruling, wave 2).
 *
 * Consumed by web-admin (Dev-D) and implemented by the api admin/platform
 * modules (Dev-B). Changes require SME sign-off.
 *
 * Envelope: unlike /floor and /ext (ApiResult<T>), the /admin and /platform
 * tiers follow the WorkLogix pattern — plain JSON bodies on success, standard
 * Nest HTTP exceptions ({ statusCode, message }) on error.
 *
 * Route tiers (from the engineering contract):
 *   /platform/*  Entra JWT + PlatformAdminGuard, cross-tenant, SECURITY DEFINER only
 *   /admin/t/:tenantId/*  Entra JWT + TenantMembershipGuard (membership role or platform admin), RLS-bound
 *   /me/tenants           Entra JWT only — the signed-in person's tenants (picker)
 */
// ------------------------------------------------------------------ routes
export const PLATFORM_ROUTES = {
    access: 'platform/access', // GET  -> PlatformAccess
    tenants: 'platform/tenants', // GET -> TenantSummary[] | POST ProvisionTenantRequest -> ProvisionTenantResult
};
export const MEMBER_ROLES = Object.freeze(['admin', 'manager', 'viewer']);
const MEMBER_ROLE_RANK = Object.freeze({
    viewer: 1,
    manager: 2,
    admin: 3,
});
export function isMemberRole(x) {
    return typeof x === 'string' && MEMBER_ROLES.includes(x);
}
/** True when `held` is at least `required` (viewer < manager < admin). */
export function roleSatisfies(held, required) {
    return MEMBER_ROLE_RANK[held] >= MEMBER_ROLE_RANK[required];
}
/** The ONE email matching rule: lower-cased + trimmed, otherwise exact. */
export function normalizeEmail(raw) {
    return raw.trim().toLowerCase();
}
export const ME_ROUTES = { tenants: 'me/tenants' }; // GET -> MyTenantsResponse
/** Every admin route is tenant-qualified (tenancy v1): `t` = app.tenant.id (UUID), never a slug. */
export const ADMIN_ROUTES = {
    siteConfig: (t) => `admin/t/${t}/site-config`,
    tools: (t) => `admin/t/${t}/tools`,
    tool: (t, tool) => `admin/t/${t}/tools/${tool}`,
    employees: (t) => `admin/t/${t}/employees`,
    employee: (t, id) => `admin/t/${t}/employees/${id}`,
    employeePin: (t, id) => `admin/t/${t}/employees/${id}/pin`,
    devices: (t) => `admin/t/${t}/devices`,
    deviceRotate: (t, id) => `admin/t/${t}/devices/${id}/rotate`,
    device: (t, id) => `admin/t/${t}/devices/${id}`,
    extClients: (t) => `admin/t/${t}/ext-clients`,
    extClient: (t, id) => `admin/t/${t}/ext-clients/${id}`,
    members: (t) => `admin/t/${t}/members`,
    member: (t, id) => `admin/t/${t}/members/${id}`,
};
//# sourceMappingURL=admin-contracts.js.map